import { type FC, useEffect } from "react";
import { usePlaidLink } from "react-plaid-link";

import type { PlaidLinkOnSuccessMetadata } from "react-plaid-link";

interface PlaidLinkLauncherProps {
  linkToken: string;
  onSuccess: (publicToken: string, metadata: PlaidLinkOnSuccessMetadata) => void;
  onExit: () => void;
}

export const PlaidLinkLauncher: FC<PlaidLinkLauncherProps> = ({ linkToken, onSuccess, onExit }) => {
  const { ready, open } = usePlaidLink({
    token: linkToken,
    onSuccess,
    onExit: () => onExit(),
  });

  useEffect(() => {
    if (ready) {
      open();
    }
  }, [ready, open]);

  return null;
};
